import type { UserInfoResponse } from '@routes/___shared___/user.api.ts';
import { getUpdatedFormFieldsWithErrors } from '@routes/auth/___shared___/helpers.ts';
import type { ClientDetailsResponse } from '@shared/api/clientDetail.api.ts';
import type { GeneralError } from '@shared/types/generalError.ts';
import type { FormField } from '@types';

export const attachAvatarContentIdConditionally = (
    avatarContentId: string | null,
    alreadyModifiedFields?: Record<string, any> | null,
): Partial<{ avatarContentId: string }> => {
    if (!avatarContentId) return {};

    if (avatarContentId === alreadyModifiedFields?.avatarContentId) {
        return {};
    }

    return { avatarContentId };
};

export const updateFormFieldsWithErrors = (
    err: GeneralError,
    formFields: FormField[],
    setFormFields: (updatedFields: FormField[]) => void,
) => {
    if (!err) return;

    const typedError = err as GeneralError;

    const mappedErrors =
        typedError?.data?.errorFields?.length > 0
            ? typedError.data.errorFields.map((error) => ({
                  name: error.name,
                  message: error.error,
              }))
            : [];

    const { updatedFields } = getUpdatedFormFieldsWithErrors(formFields, mappedErrors);
    setFormFields(updatedFields);
};

export const getProfileHeaderData = (
    clientDetails: ClientDetailsResponse | null,
    userInfo: UserInfoResponse | null,
    isCrewUser: boolean,
): { rank: string; organisation: string; location: string; isOnboard: boolean; titleName: string } => {
    if (userInfo === null || clientDetails === null) {
        return {
            rank: '',
            organisation: '',
            location: '',
            isOnboard: false,
            titleName: '',
        };
    }

    if (isCrewUser) {
        const { locations, organisations } = clientDetails;
        const employmentDetails = userInfo.employmentDetails.crewEmploymentDetails;
        const clientVesselId = employmentDetails?.vesselId;
        const clientOrganisationId = employmentDetails?.rankDepartmentId;

        const rank = employmentDetails.rankName;
        const location = locations.find((l) => l.id === clientVesselId)?.name || '';
        const organisation = organisations.find((o) => o.id === clientOrganisationId)?.name || '';
        const isOnboard = employmentDetails.isOnboard;

        return { rank, location, organisation, isOnboard, titleName: '' };
    }

    const employmentDetails = userInfo.employmentDetails.shoreEmploymentDetails;
    const titleName = employmentDetails.titleName;

    return {
        rank: '',
        organisation: '',
        location: '',
        isOnboard: false,
        titleName,
    };
};
